import React, {Component} from 'react';
import Axios from 'axios';

import classes from './SignupForm.module.css'

import SignedUpModal from '../../components/SignedUpModal/SignedUpModal';
import ErrorModal from '../../components/ErrorModal/ErrorModal'

import Form from 'react-bootstrap/Form'
import Button from 'react-bootstrap/Button';
import Col from 'react-bootstrap/Col';
import Row from 'react-bootstrap/Row';
import Collapse from 'react-bootstrap/Collapse';

class SignupForm extends Component {
    state = {
        otherEnabled: false,    // will show the 'other' text input field
        formSubmitted: false,   // will trigger the success modal to show
        formValidated: false,   // will show the validated states of the form fields if validation fails
        signupErrored: false    // will show error modal TODO
    }

    CountryList(){
        return(
            <>
            <option value="AF">Afghanistan</option>
            <option value="AX">Åland Islands</option>
            <option value="AL">Albania</option>
            <option value="DZ">Algeria</option>
            <option value="AS">American Samoa</option>
            <option value="AD">Andorra</option>
            <option value="AO">Angola</option>
            <option value="AI">Anguilla</option>
            <option value="AQ">Antarctica</option>
            <option value="AG">Antigua and Barbuda</option>
            <option value="AR">Argentina</option>
            <option value="AM">Armenia</option>
            <option value="AW">Aruba</option>
            <option value="AU">Australia</option>
            <option value="AT">Austria</option>
            <option value="AZ">Azerbaijan</option>
            <option value="BS">Bahamas</option>
            <option value="BH">Bahrain</option>
            <option value="BD">Bangladesh</option>
            <option value="BB">Barbados</option>
            <option value="BY">Belarus</option>
            <option value="BE">Belgium</option>
            <option value="BZ">Belize</option>
            <option value="BJ">Benin</option>
            <option value="BM">Bermuda</option>
            <option value="BT">Bhutan</option>
            <option value="BO">Bolivia, Plurinational State of</option>
            <option value="BQ">Bonaire, Sint Eustatius and Saba</option>
            <option value="BA">Bosnia and Herzegovina</option>
            <option value="BW">Botswana</option>
            <option value="BV">Bouvet Island</option>
            <option value="BR">Brazil</option>
            <option value="IO">British Indian Ocean Territory</option>
            <option value="BN">Brunei Darussalam</option>
            <option value="BG">Bulgaria</option>
            <option value="BF">Burkina Faso</option>
            <option value="BI">Burundi</option>
            <option value="KH">Cambodia</option>
            <option value="CM">Cameroon</option>
            <option value="CA">Canada</option>
            <option value="CV">Cape Verde</option>
            <option value="KY">Cayman Islands</option>
            <option value="CF">Central African Republic</option>
            <option value="TD">Chad</option>
            <option value="CL">Chile</option>
            <option value="CN">China</option>
            <option value="CX">Christmas Island</option>
            <option value="CC">Cocos (Keeling) Islands</option>
            <option value="CO">Colombia</option>
            <option value="KM">Comoros</option>
            <option value="CG">Congo</option>
            <option value="CD">Congo, the Democratic Republic of the</option>
            <option value="CK">Cook Islands</option>
            <option value="CR">Costa Rica</option>
            <option value="CI">Côte d'Ivoire</option>
            <option value="HR">Croatia</option>
            <option value="CU">Cuba</option>
            <option value="CW">Curaçao</option>
            <option value="CY">Cyprus</option>
            <option value="CZ">Czech Republic</option>
            <option value="DK">Denmark</option>
            <option value="DJ">Djibouti</option>
            <option value="DM">Dominica</option>
            <option value="DO">Dominican Republic</option>
            <option value="EC">Ecuador</option>
            <option value="EG">Egypt</option>
            <option value="SV">El Salvador</option>
            <option value="GQ">Equatorial Guinea</option>
            <option value="ER">Eritrea</option>
            <option value="EE">Estonia</option>
            <option value="ET">Ethiopia</option>
            <option value="FK">Falkland Islands (Malvinas)</option>
            <option value="FO">Faroe Islands</option>
            <option value="FJ">Fiji</option>
            <option value="FI">Finland</option>
            <option value="FR">France</option>
            <option value="GF">French Guiana</option>
            <option value="PF">French Polynesia</option>
            <option value="TF">French Southern Territories</option>
            <option value="GA">Gabon</option>
            <option value="GM">Gambia</option>
            <option value="GE">Georgia</option>
            <option value="DE">Germany</option>
            <option value="GH">Ghana</option>
            <option value="GI">Gibraltar</option>
            <option value="GR">Greece</option>
            <option value="GL">Greenland</option>
            <option value="GD">Grenada</option>
            <option value="GP">Guadeloupe</option>
            <option value="GU">Guam</option>
            <option value="GT">Guatemala</option>
            <option value="GG">Guernsey</option>
            <option value="GN">Guinea</option>
            <option value="GW">Guinea-Bissau</option>
            <option value="GY">Guyana</option>
            <option value="HT">Haiti</option>
            <option value="HM">Heard Island and McDonald Islands</option>
            <option value="VA">Holy See (Vatican City State)</option>
            <option value="HN">Honduras</option>
            <option value="HK">Hong Kong</option>
            <option value="HU">Hungary</option>
            <option value="IS">Iceland</option>
            <option value="IN">India</option>
            <option value="ID">Indonesia</option>
            <option value="IR">Iran, Islamic Republic of</option>
            <option value="IQ">Iraq</option>
            <option value="IE">Ireland</option>
            <option value="IM">Isle of Man</option>
            <option value="IL">Israel</option>
            <option value="IT">Italy</option>
            <option value="JM">Jamaica</option>
            <option value="JP">Japan</option>
            <option value="JE">Jersey</option>
            <option value="JO">Jordan</option>
            <option value="KZ">Kazakhstan</option>
            <option value="KE">Kenya</option>
            <option value="KI">Kiribati</option>
            <option value="KP">Korea, Democratic People's Republic of</option>
            <option value="KR">Korea, Republic of</option>
            <option value="KW">Kuwait</option>
            <option value="KG">Kyrgyzstan</option>
            <option value="LA">Lao People's Democratic Republic</option>
            <option value="LV">Latvia</option>
            <option value="LB">Lebanon</option>
            <option value="LS">Lesotho</option>
            <option value="LR">Liberia</option>
            <option value="LY">Libya</option>
            <option value="LI">Liechtenstein</option>
            <option value="LT">Lithuania</option>
            <option value="LU">Luxembourg</option>
            <option value="MO">Macao</option>
            <option value="MK">Macedonia, the former Yugoslav Republic of</option>
            <option value="MG">Madagascar</option>
            <option value="MW">Malawi</option>
            <option value="MY">Malaysia</option>
            <option value="MV">Maldives</option>
            <option value="ML">Mali</option>
            <option value="MT">Malta</option>
            <option value="MH">Marshall Islands</option>
            <option value="MQ">Martinique</option>
            <option value="MR">Mauritania</option>
            <option value="MU">Mauritius</option>
            <option value="YT">Mayotte</option>
            <option value="MX">Mexico</option>
            <option value="FM">Micronesia, Federated States of</option>
            <option value="MD">Moldova, Republic of</option>
            <option value="MC">Monaco</option>
            <option value="MN">Mongolia</option>
            <option value="ME">Montenegro</option>
            <option value="MS">Montserrat</option>
            <option value="MA">Morocco</option>
            <option value="MZ">Mozambique</option>
            <option value="MM">Myanmar</option>
            <option value="NA">Namibia</option>
            <option value="NR">Nauru</option>
            <option value="NP">Nepal</option>
            <option value="NL">Netherlands</option>
            <option value="NC">New Caledonia</option>
            <option value="NZ">New Zealand</option>
            <option value="NI">Nicaragua</option>
            <option value="NE">Niger</option>
            <option value="NG">Nigeria</option>
            <option value="NU">Niue</option>
            <option value="NF">Norfolk Island</option>
            <option value="MP">Northern Mariana Islands</option>
            <option value="NO">Norway</option>
            <option value="OM">Oman</option>
            <option value="PK">Pakistan</option>
            <option value="PW">Palau</option>
            <option value="PS">Palestinian Territory, Occupied</option>
            <option value="PA">Panama</option>
            <option value="PG">Papua New Guinea</option>
            <option value="PY">Paraguay</option>
            <option value="PE">Peru</option>
            <option value="PH">Philippines</option>
            <option value="PN">Pitcairn</option>
            <option value="PL">Poland</option>
            <option value="PT">Portugal</option>
            <option value="PR">Puerto Rico</option>
            <option value="QA">Qatar</option>
            <option value="RE">Réunion</option>
            <option value="RO">Romania</option>
            <option value="RU">Russian Federation</option>
            <option value="RW">Rwanda</option>
            <option value="BL">Saint Barthélemy</option>
            <option value="SH">Saint Helena, Ascension and Tristan da Cunha</option>
            <option value="KN">Saint Kitts and Nevis</option>
            <option value="LC">Saint Lucia</option>
            <option value="MF">Saint Martin (French part)</option>
            <option value="PM">Saint Pierre and Miquelon</option>
            <option value="VC">Saint Vincent and the Grenadines</option>
            <option value="WS">Samoa</option>
            <option value="SM">San Marino</option>
            <option value="ST">Sao Tome and Principe</option>
            <option value="SA">Saudi Arabia</option>
            <option value="SN">Senegal</option>
            <option value="RS">Serbia</option>
            <option value="SC">Seychelles</option>
            <option value="SL">Sierra Leone</option>
            <option value="SG">Singapore</option>
            <option value="SX">Sint Maarten (Dutch part)</option>
            <option value="SK">Slovakia</option>
            <option value="SI">Slovenia</option>
            <option value="SB">Solomon Islands</option>
            <option value="SO">Somalia</option>
            <option value="ZA">South Africa</option>
            <option value="GS">South Georgia and the South Sandwich Islands</option>
            <option value="SS">South Sudan</option>
            <option value="ES">Spain</option>
            <option value="LK">Sri Lanka</option>
            <option value="SD">Sudan</option>
            <option value="SR">Suriname</option>
            <option value="SJ">Svalbard and Jan Mayen</option>
            <option value="SZ">Swaziland</option>
            <option value="SE">Sweden</option>
            <option value="CH">Switzerland</option>
            <option value="SY">Syrian Arab Republic</option>
            <option value="TW">Taiwan, Province of China</option>
            <option value="TJ">Tajikistan</option>
            <option value="TZ">Tanzania, United Republic of</option>
            <option value="TH">Thailand</option>
            <option value="TL">Timor-Leste</option>
            <option value="TG">Togo</option>
            <option value="TK">Tokelau</option>
            <option value="TO">Tonga</option>
            <option value="TT">Trinidad and Tobago</option>
            <option value="TN">Tunisia</option>
            <option value="TR">Turkey</option>
            <option value="TM">Turkmenistan</option>
            <option value="TC">Turks and Caicos Islands</option>
            <option value="TV">Tuvalu</option>
            <option value="UG">Uganda</option>
            <option value="UA">Ukraine</option>
            <option value="AE">United Arab Emirates</option>
            <option value="GB">United Kingdom</option>
            <option value="US">United States</option>
            <option value="UM">United States Minor Outlying Islands</option>
            <option value="UY">Uruguay</option>
            <option value="UZ">Uzbekistan</option>
            <option value="VU">Vanuatu</option>
            <option value="VE">Venezuela, Bolivarian Republic of</option>
            <option value="VN">Viet Nam</option>
            <option value="VG">Virgin Islands, British</option>
            <option value="VI">Virgin Islands, U.S.</option>
            <option value="WF">Wallis and Futuna</option>
            <option value="EH">Western Sahara</option>
            <option value="YE">Yemen</option>
            <option value="ZM">Zambia</option>
            <option value="ZW">Zimbabwe</option>
            </>
        )
    }

    FormSubmissionHandler = ( event ) => {
        const form = event.currentTarget;
        this.setState({formValidated: true})
        if (form.checkValidity() === false) {
        event.preventDefault();
        event.stopPropagation();
        }
        else {
            event.preventDefault();
            const requestBody={
                'fName': document.getElementById("fName").value,
                'lName': document.getElementById("lName").value,
                'teamName': document.getElementById("teamName").value,
                'email': document.getElementById("email").value,
                'country': document.getElementById("country").value,
                'other': document.getElementById("otherEnabled").checked ? document.getElementById("other").value : "",
                'player': document.getElementById("player").checked ? 1 : 0,
                'coach': document.getElementById("coach").checked ? 1 : 0
            }
            const self = this;
            Axios.post('https://gwcna3yjh9.execute-api.eu-west-1.amazonaws.com/prod', requestBody)
            .then(function (response) {
                console.log(response);
                self.setState({formSubmitted: true, formValidated: false})
            })
            .catch(function (error) {
                // handle error
                console.log(error);
                self.setState({signupErrored: true})
            })
        }
    }

    FlipCheckboxStateHandler(stateToFlip) {
        const oldState = this.state[stateToFlip];
        const newState = !oldState;
        this.setState({[stateToFlip]: newState})
    }
    
    CloseModalHandler = () => {
        this.setState({
            otherEnabled: false,
            formSubmitted: false
        })
        document.getElementById("signUpForm").reset();
    }

    CloseErrorModalHandler = () => {
        this.setState({
            signupErrored: false
        })
    }
    render() {
        return(
            <Form noValidate validated={this.state.formValidated} className={classes.Form} onSubmit={this.FormSubmissionHandler} id='signUpForm'>
                <p className={classes.Text}> To receive an <strong>early bird discount</strong> and be the first to hear about CleatSheet's features, sign up for our mailing list below: </p>
                <Row>
                    <Col style={{minWidth: '141px', paddingBottom: '15px'}}>
                        <Form.Control required maxLength='50' type='input' placeholder="First Name" id='fName' style={{preventScroll: 'true'}}/>
                        <Form.Control.Feedback type='invalid'>Please provide your first name.</Form.Control.Feedback>
                    </Col>
                    <Col style={{minWidth: '141px', paddingBottom: '15px'}}>
                        <Form.Control required maxLength='50' type='input' placeholder="Last Name" id='lName' />
                        <Form.Control.Feedback type='invalid'>Please provide your last name.</Form.Control.Feedback>
                    </Col>
                </Row>
                <Row>
                    <Col style={{paddingBottom: '15px'}}>
                        <Form.Control required maxLength='254' type='email' placeholder="Email Address" id='email' />
                        <Form.Control.Feedback type='invalid'>Please provide a valid email address.</Form.Control.Feedback>
                    </Col>
                </Row>
                <Row>
                    <Col style={{minWidth: '222px', paddingBottom: '15px'}}>
                        <Form.Control noValidate maxLength='50' type='input' placeholder="Team Name (optional)" id='teamName'/>
                    </Col>
                    <Col style={{minWidth: '222px', paddingBottom: '15px'}}>
                        <Form.Control as="select" required id='country' defaultValue=''>
                            <option disabled defaultValue value=''>Choose Your Country...</option>
                            {this.CountryList()}
                        </Form.Control>
                        <Form.Control.Feedback type='invalid'>Please select a country.</Form.Control.Feedback>
                    </Col>
                </Row>

                <fieldset>
                    <Form.Group as={Row}>
                        <Form.Label as="legend" style={{color: '#575756'}} column sm={2}>
                            Role
                        </Form.Label>
                        <Col>
                            <Form.Check type="checkbox" label="Player" id="player"/>
                            <Form.Check type="checkbox" label="Coach" id="coach"/>
                            <Form.Row>
                                <Col>
                                    <Form.Check type="checkbox" label="Other" id="otherEnabled" onChange={() => this.FlipCheckboxStateHandler("otherEnabled")}/>
                                </Col>
                                <Col style={{minWidth: '141px'}}>
                                    <Collapse in={this.state.otherEnabled}>
                                            <Form.Control maxLength='50' type='input' placeholder="Other Role(s)" id='other' />
                                    </Collapse>
                                </Col>
                            </Form.Row>
                        </Col>
                    </Form.Group>
                </fieldset>
                <Form.Group as={Row} style={{justifyContent:'center'}}>
                        <Button type="submit" variant="outline-success">Register Your Interest</Button>
                </Form.Group>
                <SignedUpModal show={this.state.formSubmitted} closeModal={this.CloseModalHandler}/>
                <ErrorModal show={this.state.signupErrored} closeModal={this.CloseErrorModalHandler}></ErrorModal>
            </Form>       
        )
    }
}


export default SignupForm